module.exports = __webpack_public_path__ + "static/media/sell_finish_service_make_7.007194bb.jpg";